import {
  browserSafeNewDate,
  dropTimeZoneFromDate,
} from '../../../../../../shared/libraries/utils/date'
import moment from 'moment'
import { DATE_FORMAT } from '../../../../../../constants'

const ambassadorActivityMapper = mission => {
  const { id, client, location, timeStart, timeOfDay, user } = mission

  const localDate = browserSafeNewDate(dropTimeZoneFromDate(timeStart))

  return {
    ...mission,
    id,
    'CLIENT': client.name,
    'DATE': moment(localDate).format(DATE_FORMAT),
    'TIME': timeOfDay,
    'LOCATION': location ? location.name : '-',
    'NAME': user ? `${user.firstName} ${user.lastName}` : '',
    'STATUS': mission.status,
    'ACTIONS': '',
  }
}

const missionSorter = (a, b) =>
  new Date(b.timeStart).getTime() - new Date(a.timeStart).getTime()

export const getActivityTableData = ambassadorActivities =>
  Array.from(ambassadorActivities)
    .sort(missionSorter)
    .map(ambassadorActivityMapper)

export const TableHeader = [
  'CLIENT',
  'DATE',
  'TIME',
  'LOCATION',
  'NAME',
  'STATUS',
  'ACTIONS',
]



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/Components/ActivityTable/utils.js